import React, { useState } from 'react';
import {
  IAuditoriaLancamentoManualResultado,
  IItemLancamentoManual,
} from '../interfaces/IAuditoriaLancamentoManual';
import { formatCurrency, formatDate } from '../utils/formatters';

interface Props {
  resultado: IAuditoriaLancamentoManualResultado;
}



const getIconeStatus = (status: string) => {
  switch (status) {
    case 'ERRO':
      return 'bi-exclamation-circle-fill';
    case 'ALERTA':
      return 'bi-exclamation-triangle-fill';
    case 'AVISO':
      return 'bi-info-circle-fill';
    default:
      return 'bi-check-circle-fill';
  }
};

const AuditoriaLancamentoManualDetalhe: React.FC<Props> = ({ resultado }) => {
  const [itemExpandido, setItemExpandido] = useState<string | null>(null);
  const [fundamentacaoAberta, setFundamentacaoAberta] = useState(false);

  const lancamentosManuais = resultado.lancamentosManuais || [];

  const alternarExpandir = (chave: string) => {
    setItemExpandido(itemExpandido === chave ? null : chave);
  };

  return (
    <>
      <div className={`auditoria-alert status-${resultado.status}`}>
        <i className={`bi ${getIconeStatus(resultado.status)} auditoria-alert-icon`} />
        <div>
          <strong>Auditoria de Lançamentos com Palavra-Chave "Manual" — {resultado.status}</strong>
          <div>{resultado.mensagemDirecionamento}</div>
        </div>
      </div>

      <div className='auditoria-kpis'>
        <div className='auditoria-kpi auditoria-kpi-disabled'>
          <div className='auditoria-kpi-label'>Impacto Fiscal Estimado</div>
          <div className='auditoria-kpi-value'>{formatCurrency(resultado.impactoFiscalTotal)}</div>
          <div className='auditoria-kpi-help'>Sem multa aplicável — alerta de Revisão Necessária (governança/conformidade documental).</div>
        </div>

        <div className='auditoria-kpi'>
          <div className='auditoria-kpi-label'>Lançamentos Analisados / Manuais</div>
          <div className='auditoria-kpi-value'>
            {resultado.totalLancamentosAnalisados} / <span className='auditoria-contador auditoria-contador-alerta'>{lancamentosManuais.length}</span>
          </div>
          <div className='auditoria-kpi-help'>Lançamentos manuais analisados no período (exclui saldos/encerramento automáticos).</div>
        </div>

        <div className='auditoria-kpi'>
          <div className='auditoria-kpi-label'>Fundamentação</div>
          <div className='auditoria-kpi-value'>
            <button
              type='button'
              className='btn btn-sm btn-light-primary'
              onClick={() => setFundamentacaoAberta(!fundamentacaoAberta)}
            >
              <i className='bi bi-journal-check me-1' />
              {fundamentacaoAberta ? 'Ocultar fundamentação' : 'Ver fundamentação legal'}
            </button>
          </div>
          <div className='auditoria-kpi-help'>Base contábil aplicada aos lançamentos manuais.</div>
        </div>
      </div>

      {fundamentacaoAberta && (
        <div className='auditoria-card'>
          <div><strong>Fundamentação Contábil:</strong> {resultado.fundamentacaoContabil}</div>
        </div>
      )}

      <div className='auditoria-card'>
        <h3>Lançamentos com Histórico Citando "Manual"</h3>
        <p className='text-muted'>
          Lançamentos (Ativo, Passivo e Resultado) cujo histórico cita "manual" — operação sem origem sistêmica
          integrada, sujeita a revisão e parametrização de origem.
        </p>

        {lancamentosManuais.length === 0 && (
          <div className='text-muted mt-4'>Nenhum lançamento com histórico citando "manual" identificado no período.</div>
        )}

        {lancamentosManuais.length > 0 && (
          <div className='table-responsive mt-4'>
            <table className='auditoria-table'>
              <thead>
                <tr>
                  <th>Conta</th>
                  <th>Data</th>
                  <th>Histórico</th>
                  <th className='text-end'>Valor</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {lancamentosManuais.map((item: IItemLancamentoManual, idx) => {
                  const chave = `lm-${item.empresaId}-${item.contaContabil}-${idx}`;
                  const expandido = itemExpandido === chave;

                  return (
                    <React.Fragment key={chave}>
                      <tr className='auditoria-row-tributo status-alerta' onClick={() => alternarExpandir(chave)}>
                        <td>
                          <strong>{item.descricaoConta || item.contaContabil}</strong>
                          <div className='text-muted' style={{ fontSize: 11 }}>{item.contaContabil}</div>
                        </td>
                        <td>{formatDate(item.dataLancamento)}</td>
                        <td style={{ maxWidth: 280 }}>{item.historico}</td>
                        <td className='text-end'>{formatCurrency(item.valor)}</td>
                        <td>
                          <span className={`auditoria-status status-${item.status}`}>{item.status}</span>
                          <i className={`bi ${expandido ? 'bi-chevron-up' : 'bi-chevron-down'} ms-2 text-muted`} />
                        </td>
                      </tr>

                      {expandido && (
                        <tr>
                          <td colSpan={5} style={{ background: '#fffbeb' }}>
                            <div className='py-2 px-3'>
                              <div className='auditoria-alert status-ALERTA mb-2'>
                                <i className='bi bi-exclamation-triangle-fill auditoria-alert-icon' />
                                <div>{item.mensagemObrigatoria}</div>
                              </div>
                              <div><strong>Lançamento (Histórico):</strong> {item.historico}.</div>
                              <div><strong>Fundamentação Contábil:</strong> {resultado.fundamentacaoContabil}</div>
                              <div className='mt-1 text-muted' style={{ fontSize: 12 }}>{item.memoriaCalculo}</div>
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );
};

export default AuditoriaLancamentoManualDetalhe;
